import request from '@/utils/request'
import { isUseAPI } from '@/utils/check'

//근골격계 유해요인 조사목록 조회
export function getMuscleHazardSearch(param, isNotify) {
  return request({
    url: '/api/getMuscleHazardSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 레포트
export function getMuscleHazardSearchReport(param) {
  let responseType = "blob"
  return request({
    url: `/api/getMuscleHazardSearchReport`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data:param,
    responseType: responseType
  })
}

//근골격계 유해요인 조사목록 저장
export function saveMuscleHazardSearch(param, isNotify) {
  return request({
    url: '/api/saveMuscleHazardSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 삭제
export function deleteMuscleHazardSearch(param, isNotify) {
  return request({
    url: '/api/deleteMuscleHazardSearch',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 디테일 조회
export function getMuscleHazardSearchDetail(param, isNotify) {
  return request({
    url: '/api/getMuscleHazardSearchDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'searched' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 디테일 저장
export function saveMuscleHazardSearchDetail(param, isNotify) {
  return request({
    url: '/api/saveMuscleHazardSearchDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'saved' } //searched, saved,deleted
  })
}

//근골격계 유해요인 조사목록 디테일 삭제
export function deleteMuscleHazardSearchDetail(param, isNotify) {
  return request({
    url: '/api/deleteMuscleHazardSearchDetail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data: param,
    meta: { apiVersion: '1.0.0' },
    Notify: { use: isNotify, apitype: 'deleted' } //searched, saved,deleted
  })
}

